/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxOverviewStudentController", function OverviewStudentController(
	$scope,
	$filter,
	$interval,
	$timeout,
	$window,
	$location,
	$cookies,

	examStatus,
	examState,
	dxSession,
	dxApiV1Students,
	dxApiV1Session,
	dxApiV1LoginCode
) {
	"use strict";

	var chromeRegex = new RegExp(/\bCrOS\b/);
	var role = dxSession.getRole();

	$scope.isChromeOS = chromeRegex.test($window.navigator.userAgent);
	$scope.exams = [];
	$scope.organizationName = role.organizationTitle;

	dxApiV1Students.examList(-1 * role.id).then(function setExams(exams) {
		$scope.exams = exams || [];
	});

	$scope.filterPublished = function filterPublished(exam) {
		return exam.state === examState.FINAL && exam.status === examStatus.PUBLISHED;
	};

	$scope.filterNotPublished = function filterNotPublished(exam) {
		return exam.state === examState.FINAL && exam.status !== examStatus.PUBLISHED;
	};

	$scope.filterNotHandedIn = function filterNotHandedIn(exam) {
		return exam.state !== examState.FINAL;
	};

	$scope.formatDate = function formatDate(dateString) {
		var date = new Date(dateString);

		if (date.getFullYear() === 1) {
			return "--";
		}
		return $filter("date")(date, "yyyy-MM-dd HH:mm");
	};

	$scope.openClient = function openClient(scheme) {
		var region = "europe";
		switch ($location.host()) {
			case "digiexam-live.appspot.com":
			case "app.digiexam.com":
				region = "europe";
				break;
			case "digiexam-live-us.appspot.com":
			case "app-us.digiexam.com":
				region = "usa";
				break;
			case "digiexam-demo.appspot.com":
				region = "demo";
				break;
			case "digiexam-manual.appspot.com":
				region = "manual";
				break;
			case "digiexam-release.appspot.com":
				region = "release";
				break;
			case "localhost":
				region = "localhost";
				break;
		}

		var locale = "en";
		var languageCookie = $cookies.getObject("language");
		if (languageCookie && languageCookie.locale) {
			locale = languageCookie.locale;
		}

		dxApiV1Session.getToken().then(function openDeepLink(response) {
			if (!response || !response.authToken) {
				return;
			}

			// eslint-disable-next-line no-undef
			var deepLinkUrl = new URL(scheme + "://");
			deepLinkUrl.searchParams.set("region", region);
			deepLinkUrl.searchParams.set("token", response.authToken);
			deepLinkUrl.searchParams.set("language", locale);

			$window.location.href = deepLinkUrl.toString();
		});
	};

	$scope.openOldClient = function openOldClient() {
		$scope.openClient("digiexam");
	};

	$scope.openNewClient = function openNewClient() {
		$scope.openClient("digix");
	};

	function formatCode(raw) {
		var code = raw.replace(/\s/g, "");
		return code.slice(0, 2) + " " + code.slice(2);
	}

	function secondsUntil(isoTimestamp) {
		return Math.max(0, Math.floor((new Date(isoTimestamp) - new Date()) / 1000));
	}

	$scope.chromebookCode = null;
	$scope.chromebookCodeError = false;
	$scope.chromebookCodeLoading = false;
	$scope.chromebookCodeCopied = false;
	$scope.chromebookCodeSecondsLeft = 0;

	var countdownInterval = null;

	function startCountdown(expiresAt) {
		if (countdownInterval) {
			$interval.cancel(countdownInterval);
		}
		$scope.chromebookCodeSecondsLeft = secondsUntil(expiresAt);
		countdownInterval = $interval(function tick() {
			var secondsLeft = secondsUntil(expiresAt);
			$scope.chromebookCodeSecondsLeft = secondsLeft;
			if (secondsLeft <= 0) {
				$interval.cancel(countdownInterval);
				$scope.chromebookCode = null;
			}
		}, 1000);
	}

	function withToken(callback) {
		$scope.chromebookCodeError = false;
		$scope.chromebookCodeLoading = true;
		dxApiV1Session.getToken().then(function onToken(session) {
			if (!session || !session.authToken) {
				$scope.chromebookCodeError = true;
				$scope.chromebookCodeLoading = false;
				return;
			}
			callback(session.authToken);
		}, function onError() {
			$scope.chromebookCodeError = true;
			$scope.chromebookCodeLoading = false;
		});
	}

	function applyCode(data) {
		if (data.code === "not_found") {
			$scope.chromebookCodeLoading = false;
			return;
		}
		$scope.chromebookCode = formatCode(data.code);
		$scope.chromebookCodeLoading = false;
		startCountdown(data.expires_at);
	}

	function onGetActiveError(response) {
		if (response.status === 404) {
			$scope.chromebookCodeLoading = false;
		} else {
			$scope.chromebookCodeError = true;
			$scope.chromebookCodeLoading = false;
		}
	}

	withToken(function loadActive(authToken) {
		dxApiV1LoginCode.getActive(authToken).then(applyCode, onGetActiveError);
	});

	$scope.generateChromebookCode = function generateChromebookCode() {
		withToken(function generate(authToken) {
			dxApiV1LoginCode.generate(authToken).then(applyCode, function onError() {
				$scope.chromebookCodeError = true;
				$scope.chromebookCodeLoading = false;
			});
		});
	};

	$scope.retryChromebookCode = function retryChromebookCode() {
		withToken(function loadActive(authToken) {
			dxApiV1LoginCode.getActive(authToken).then(applyCode, onGetActiveError);
		});
	};

	$scope.$on("$destroy", function onDestroy() {
		if (countdownInterval) {
			$interval.cancel(countdownInterval);
		}
	});

	$scope.formatCountdown = function formatCountdown(seconds) {
		return sprintf("%d:%02d", Math.floor(seconds / 60), seconds % 60); // eslint-disable-line no-undef
	};

	$scope.copyChromebookCode = function copyChromebookCode() {
		$window.navigator.clipboard.writeText($scope.chromebookCode);
		$scope.chromebookCodeCopied = true;
		$timeout(function resetCopied() {
			$scope.chromebookCodeCopied = false;
		}, 2000);
	};
});
